import React, { Component } from "react";
import Slider from "react-slick";
import { connect } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import shop from "../../../api/shop";
import store from "../../../store";
import { Product4 } from "../../../services/script";
import {
  addToCart,
  addToWishlist,
  addToCompare,
  removeWishlist,
  addItemToCart,
  FetchCategprod,
} from "../../../actions";
import ProductItem from "./product-item";
import "./proCard.css";
import "./collection.css";  /* bring in shared collection styles including .col-see-all-link */
import Loader from "../../../svg_code/loader";
import history from "../../../history";
import { ProductCardSkeletonRow } from "../../common/loaders/SkeletonLoaders";

class Collection2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      products: [],
    };
  }

  fetchCategoryProducts = () => {
    const { categoryID } = this.props;
    if (!categoryID) return;
    const paramsObj = {
      token: "true",
      currency: localStorage.getItem("changeCurrencies"),
      category_id: categoryID,
      order: "asc",
    };
    shop.CallEnginegetCategoryByProducts(paramsObj, (data) => {
      if (data && data.length > 0) {
        this.setState({ products: data, loading: false });
      } else {
        this.setState({ products: [], loading: false });
      }
    });
  };

  componentDidMount() {
    this.fetchCategoryProducts();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.categoryID !== this.props.categoryID) {
      this.setState({ loading: true, products: [] });
      this.fetchCategoryProducts();
    }
  }

  render() {
    function handleClick(e) {
      store.dispatch(removeWishlist(e));
    }
    function addItemTOCart(e) {
      document.querySelector(".loader-wrapper").style = "display: block";
      var item = { product_id: e, quantity: 1 };
      store.dispatch(addItemToCart(item));
    }

    const { items, symbol, addToCompare, title, subtitle, categoryID, SeeAllProductsBtnCdn, getallcategories, categoryData } = this.props;
    const { products, loading } = this.state;

    let objshopPage = categoryData || getallcategories?.data?.filter((e) => e?.id == categoryID)[0] || { id: categoryID, name: title };
    const featured = products;
    return (
      <div>
        {/* Header row with title & button on same line */}
        <div
          className="col2-header-row"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "1rem",               /* 16px */
            paddingBottom: "0px",             /* 16px */
            paddingLeft: "1rem",               /* 16px */
            paddingRight: "1rem",              /* 16px */
            // marginBottom: "1rem",              /* 16px */
            gap: "1.5rem",                     /* 24px */
          }}
        >
          {/* Title & Subtitle group */}
          <div style={{ flex: 1 }}>
            <span
              className="title-inner1 mob-heading"
              style={{
                fontSize: "1.375rem", /* 22px */
                fontFamily: "'Cormorant Garamond', serif",
                fontWeight: "600",
              }}
            >
              {title}
            </span>
            {subtitle ? (
              <span
                style={{
                  fontSize: "1rem", /* 16px */
                  fontFamily: "Poppins",
                  fontWeight: "400",
                }}
              >
                {" "}( {subtitle})
              </span>
            ) : null}
          </div>

          {/* See All Products button */}
          {SeeAllProductsBtnCdn ? (
            // <Link
            //   to={{
            //     pathname: "/products",
            //     search: `?category=${objshopPage.id}`,
            //     state: { categories: objshopPage },
            //   }}
            //   className="col-see-all-link"
            // >

            <Link
              to={{
                pathname: `/products/${(objshopPage?.name || title || "category").replace(/\s+/g, "-")}-${objshopPage?.id || categoryID}`,
                state: { categories: objshopPage }
              }}
              className="col-see-all-link"
            >
              <span>See All Products</span>
              <svg
                className="col-see-all-arrow"
                viewBox="0 0 24 24"
                width="13"
                height="13"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </Link>
          ) : null}
        </div>

        <section
          className="j-box pets-box ratio_square"
          style={{
            /* ✅ width: 100% — let the PARENT wrapper in TradnityMain control the width.
               Removed hardcoded "85%" that was misaligning with banners above. */
            width: "100%",
            margin: "0",
            overflow: "visible",
            paddingLeft: 0,
            paddingRight: 0,
            paddingTop: "0.625rem", /* 10px */
            paddingBottom: "1.25rem", /* 20px */
          }}
        >
          <div className="row">
            <div className="col">
              <div style={{ display: "none" }}>
                {/* Title & subtitle now in header above, keeping this for backward compatibility if needed */}
              </div>
              {featured && featured.length !== 0 ? (
                <Slider
                  {...Product4}
                  className="product-4 product-m"
                  style={{ margin: "0 4px" }}
                >
                  {featured.map((product, index) => (
                    <div key={index}>
                      <ProductItem
                        product={product}
                        product_ids={product?.id || ""}
                        category_ids={categoryID}
                        symbol={symbol}
                        onAddToCompareClicked={() => addToCompare(product)}
                        onAddToWishlistClicked={() =>
                          localStorage.getItem("customerData")
                            ? handleClick(product.id)
                            : history.push(`${process.env.PUBLIC_URL}/login`)
                        }
                        onAddToCartClicked={() => addItemTOCart(product.id)}
                        key={index}
                      />
                    </div>
                  ))}
                </Slider>
              ) : loading ? (
                <ProductCardSkeletonRow count={4} />
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "2rem 0",
                    color: "rgba(252,254,253,0.45)",
                    fontSize: "0.9rem",
                  }}
                >
                  No products available in this collection
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    items: state?.data?.deals,
    getcatebyproducts: state.categoryByProducts.getcatebyproducts,
    symbol: state.data.symbol,
    getallcategories: state.data.getCategory,

  };
}

export default connect(mapStateToProps, {
  addToCart,
  addToWishlist,
  addToCompare,
})(Collection2);